import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import logoAtlas from '../../assets/logo_atlas.png';
import { getPortalBranding } from './portalBranding';

export const portalHeaderStyles = {
  backgroundColor: 'background.paper', color: 'text.primary',
  minHeight: { xs: '64px !important', sm: '58px !important' },
  px: { xs: 2, md: 4.5 }, borderBottom: 1, borderColor: 'divider', gap: 1,
};

export const portalBrandStyles = {
  display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 },
  textDecoration: 'none', color: 'text.primary', minWidth: 0,
};

export const getPortalLogoStyles = (theme: Theme) => ({
  width: theme.headerLogo?.width ?? { xs: 32, sm: 46 },
  height: theme.headerLogo?.height ?? { xs: 32, sm: 46 },
  objectFit: 'contain', flexShrink: 0,
});

/** Visual branding only: safe to render before portal permissions are available. */
export function PortalBrand() {
  const theme = useTheme();
  const { t } = useTranslation();
  const { clientName, portalTitle } = getPortalBranding(theme, t('header.portalTitle'));
  const logo = theme.clientName ? theme.logo || logoAtlas : logoAtlas;

  return <>
    <Box component="img" src={logo} alt={clientName} sx={getPortalLogoStyles(theme)} />
    {!theme.hideHeaderClientName && <Box component="span" sx={{ display: { xs: 'none', sm: 'flex' }, flexDirection: 'column' }}>
      <Typography component="span" sx={{ color: theme.palette.atlas?.ui?.icon ?? 'primary.main', fontSize: 24, fontWeight: 700, lineHeight: 1.1 }}>
        {clientName}
      </Typography>
      {!theme.clientName && <Typography component="span" sx={{ fontSize: 10, color: 'text.secondary' }}>by Globalsyde</Typography>}
    </Box>}
    <Divider orientation="vertical" flexItem sx={{ my: 1 }} />
    <Typography component="span" noWrap sx={{ fontSize: { xs: 14, sm: 20 }, lineHeight: 1.2 }}>
      {portalTitle}
    </Typography>
  </>;
}
